import React from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { Button, FieldSelect, FieldTextInput, Form } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import { reportReasons } from '../../../../util/circleHelper';
import { required } from '../../../../util/validators';
import css from './ReportContentModal.module.css';

const ReportContentForm = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        form,
        handleSubmit,
        onChange,
        invalid,
        pristine,
        submitting,
        loading,
      } = fieldRenderProps;

      const validationMessage = <FormattedMessage id="CircleFeedPage.reportReason" />;

      return (
        <Form onSubmit={handleSubmit}>
          <div>
            <h4 className={css.reportTitle}>
              <FormattedMessage id="CircleFeedPage.reportTitle" />
            </h4>
            <h4 className={css.reportReasonTitle}>
              <FormattedMessage id="CircleFeedPage.reportReason" />
            </h4>
            <FieldSelect
              id={'reason'}
              name={'reason'}
              placeholder={'select'}
              label={'Please select a reason for reporting this content.'}
              validate={required(validationMessage)}
            >
              {reportReasons?.map(item => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </FieldSelect>
            <h4 className={css.explanationTitle}>
              <FormattedMessage id="CircleFeedPage.explanation" />
            </h4>
            <FieldTextInput
              id={'explanation'}
              name={'explanation'}
              type="textarea"
              label={'Optionally, provide an explanation.'}
              className={css.explanation}
            />
            <div className={css.reportButtonWrapper}>
              <Button type="submit" inProgress={loading} className={css.reportButton}>
                <FormattedMessage id="CircleFeedPage.reportTitle" />
              </Button>
            </div>
          </div>
        </Form>
      );
    }}
  />
);

export default ReportContentForm;
